export const REMOVE_STORE = 'REMOVE_STORE';
export const STORE_LIST = 'STORE_LIST';
export const UPDATE_STORE_CONFIG = 'UPDATE_STORE_CONFIG';
export const SET_MODIFIED = 'SET_MODIFIED';
export const SET_STORE_VERSIONS = 'SET_STORE_VERSIONS';

export const SET_ACTIVE_STORE = 'SET_ACTIVE_STORE';
export const ADD_SECTION = 'ADD_SECTION';
export const ADD_CONTENT_BLOCK = 'ADD_CONTENT_BLOCK';
export const UPDATE_CONTENT_BLOCK = 'UPDATE_CONTENT_BLOCK';
export const REMOVE_SECTION = 'REMOVE_SECTION';
export const REMOVE_CONTENT_BLOCK = 'REMOVE_CONTENT_BLOCK';
export const MOVE_CONTENT_BLOCK = 'MOVE_CONTENT_BLOCK';
export const UPDATE_SECTION = 'UPDATE_SECTION';

export const ADD_CATEGORY = 'ADD_CATEGORY';
export const ADD_SUBCATEGORY = 'ADD_SUBCATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const UPDATE_SUBCATEGORY = 'UPDATE_SUBCATEGORY';
export const REMOVE_CATEGORY = 'REMOVE_CATEGORY';
export const REMOVE_SUBCATEGORY = 'REMOVE_SUBCATEGORY';

export const LOGIN_OK = 'LOGIN_OK';
export const LOGOUT = 'LOGOUT';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';
export const ERR = 'ERR';

export const SET_CSRF_TOKEN = 'SET_CSRF_TOKEN';

export const FORGOT_PASSWORD_OK = 'FORGOT_PASSWORD_OK';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
export const SET_NEW_PASSWORD_OK = 'SET_NEW_PASSWORD_OK';
export const SET_NEW_PASSWORD_FAIL = 'SET_NEW_PASSWORD_FAIL';

export const UPDATE_BACKLINK = 'UPDATE_BACKLINK';



// WEBPACK FOOTER //
// ./src/store/actionTypes.js